import React, {useEffect, useState, useCallback} from 'react';
import logo from '../../assets/metodo-billings-marca-dashboard.png';
import { useAuth } from '../../hooks/Auth';
import { Link } from 'react-router-dom';
import {api} from '../../services/api';
import { abridgedControl } from '../../services/namefuncs';
import { format, parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
/*
import icoLogout from '../../assets/ico-logout.png';
import icoConfig from '../../assets/ico-config.png';
import icoCircle from '../../assets/ico-circle.png';
import icoInstru from '../../assets/ico-instrutor.png';
*/
import { Container, ListaALunos } from './styles';


const Header: React.FC = () => {

    const { user, signOut, updateUser } = useAuth();
    const [alunos, setAlunos] = useState([]);
    const [conjuge, setConjuge] = useState([]);
    const [regra, setRegra] = useState([]);
    const [load, setLoad] = useState(false);
    const [openAlunos, setOpenAlunos] = useState(false);
    const [openRegra, setOpenRegra] = useState(false);
    const [lido, setLido] = useState(true);
    


    const getAlunos = useCallback(async () => {    
        const params = { "emailinstrutor" : user.email }
        await api.get('/users/getInstrucionados.php', { params : params })
            .then((resp: any) => {
                setAlunos(resp.data);                     
            }
        );        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getConjuge = useCallback(async () => {    
        const params = { "emailconjuge" : user.email }
        await api.get('/users/getConjuge.php', { params : params })
            .then((resp: any) => {                
                setConjuge(resp.data); 
                if(resp.data[0]){
                    if(resp.data[0]?.nome !== undefined && resp.data[0].nome !== null){
                        updateUser({...user, conjuge: resp.data[0].nome});
                    }      
                }
            }
        );        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getRegra = useCallback(async () => {    
        const params = { "iduser" : user.iduser }
        await api.get('/regras/getRegra.php', { params : params })
            .then((resp: any) => {
                setRegra(resp.data);   
                setLido(resp.data[0] && resp.data[0]['lido'] === '0' ? false : true)                  
            }
        );        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {        
            if(alunos.length === 0){
                try {
                    getConjuge();
                    getAlunos();  
                    getRegra()                  
                    setLoad(false);
                } catch (err) {
                    // console.log(err);
                } 
            }
    }, [getAlunos, alunos, getConjuge, getRegra])

    function handleOpen(item: string){
        if(item === 'alunos'){
            setOpenAlunos(!openAlunos);
            setOpenRegra(false);
        } else {
            setOpenAlunos(false);
            setOpenRegra(!openRegra);
            changeLidoinApi();
        }
    }

    async function changeLidoinApi(){
        if(!lido){
            const data = {
                'iduser': user.iduser, 
                'idregra' : regra[0]['idregra']
            }
            try {
                await api.post('/regras/changeLido.php', data);
                setLido(true);
            } catch (error : any) {
                // console.log(error)
            }
        }
    }

    return(
        <>
        <Container>
        
            <Link to="/dashboard"><img src={logo} className="logo" alt="Método Billings - Dash 2.0" /> </Link>          
            <nav>
                {conjuge.length > 0 && (
                    <Link className="link"
                    to={{
                        pathname: "/conjuge",
                        state: { conjuge: conjuge[0] }
                      }}
                    >
                    {conjuge[0]['thumb_user'] !== null ? 
                        <img src={conjuge[0]['thumb_user']} alt="MEU CÔNJUGE" className="minithumb" />  
                     : 
                        <span title="MEU CÔNJUGE" className="material-icons">people_alt</span>              
                    }
                    </Link>  
                    )}
                {regra.length > 0 && (     
                    <button onClick={() => handleOpen('regra')}><span title="REGRA A SEGUIR" className="material-icons">notifications</span>
                    {!lido && <span className="new"></span> }</button>
                )}
                {alunos.length > 0 && (
                    <button onClick={() => handleOpen('alunos')}><span title="MEUS ALUNOS" className="material-icons">school</span></button>                
                    ) }

                    <Link to="/perfil" className="link"><span title="CONFIGURAÇÕES"className="material-icons">settings</span></Link>
                    <Link className="link" to="/dashboard"><span className="material-icons">home</span></Link>
                    <button onClick={() => signOut()}><span title="SAIR -LOGOUT" className="material-icons">logout</span></button>
            </nav> 
            

        </Container>
        {!load && alunos.length > 0 ? (            
            <ListaALunos open={openAlunos}>

                <button className="close" onClick={() => setOpenAlunos(!openAlunos)}><span className="material-icons">close</span></button>

                <h1>Lista de Alunos</h1>
                <br />
                <p>
                ABAIXO LISTAMOS OS USUÁRIOS DO MOB QUE VOCÊ É O INSTRUTOR, 
                CLIQUE NOS LINKS ABAIXO PARA ACESSAR O PAINEL DO USUÁRIO.
                </p>
                <br />
                <div className="scroll">
                {alunos.map((e: any, i: number) => 
                <a key={`aluno`+i} href={`../alunos/`+e.email}>
                {/*<Link 
                    key={`aluno`+i} 
                    to={{
                        pathname: "/alunos/"+e.email,
                        //search: "?email="+e.email,
                        state: { aluno: e }
                      }}
                    onClick={() => setOpen(!open)}
                    > */}
                    <div className="boxaluno">
                        <div className="flexcol">
                            {e.desejogravidez === 'on' ? <div className="deseja" title="DESEJA ENGRAVIDAR"><span className="material-icons">child_care</span></div> : null}
                            {e.thumb_user ? <img className="thumb" src={e.thumb_user} alt={e.nome} /> : <div className="nothumb">{e.nome.charAt(0)}</div> }
                            <div className="info">
                                <small>informações do usuário:</small>
                                <span className="nome" title={e.nomeconjuge ? e.nome + ' ♥ ' + e.nomeconjuge : e.nome}>
                                    {abridgedControl(e.nome, 13)}
                                    {e.nomeconjuge && <span className="material-icons">favorite</span> }
                                    {e.nomeconjuge && abridgedControl(e.nomeconjuge, 13) }
                                </span>
                                <div className="flex">
                                <span>{e.email}</span> 
                                <span className="edicao" title="Caso esteja desabilitado, Você pode solicitar ao aluno que ative, assim você poderá alterar o gráfico">EDIÇÃO HABILITADA? <strong className={e.edit}>{ e.edit === 'on' ? 'SIM' : 'NÃO'}</strong></span>
                                </div>
                            </div>
                        </div>
                    </div> 
                </a>                   
                )}
                <br />
                </div>
                <div className="bgfixed"></div>
            </ListaALunos>
        ) : null}

        {!load && regra.length > 0 ? (
            <ListaALunos open={openRegra}>

                <button className="close" onClick={() => setOpenRegra(!openRegra)}><span className="material-icons">close</span></button>

                <h1>Mensagens da sua instrutora</h1>
                <br />
                <p>
                ABAIXO LISTAMOS INSTRUÇÕES, MENSAGENS E AVISOS QUE SUA INSTRUTORA LHE ENVIOU.
                </p>
                <br />
                <div className="scroll">
                    {regra.map((e: any, i: number) => 
                    <div key={`regra`+i} className={i !== 0 ? 'boxregra passado' : 'boxregra'}>
                        <div className="diaregra">
                            <span className="material-icons">calendar_today</span>
                            <span className="dia">{format(parseISO(e.dataupdate), "dd")}</span>
                            <span className="mes">{format(parseISO(e.dataupdate), "MMM", { locale: ptBR})} . {format(parseISO(e.dataupdate), "Y")}</span>

                            {/*i === 0 && <span className="statusregra"><strong>REGRA ATUAL</strong></span> */}
                        </div>
                        <div className="info">
                            
                            <small>INSTRUTORA:</small> {e.nomeinstrutor}
                            <pre>
                            {e.instrucao}
                            </pre>                            
                        </div>
                    </div>
                    )}
                </div>                
                <br />
                <div className="bgfixed"></div>
            </ListaALunos>
        ) : null}
        </>
    )

}

export default Header;